export default function productPath(hit) {
  if (hit.target_url) {
    return hit.target_url;
  } else {
    return hit.breadcrumbs?.[hit.breadcrumbs?.length - 1]?.path || '';
  }
}
